import { createSelector } from "@reduxjs/toolkit";
import selectFitRaw from "./selectFitRaw";

export default createSelector(selectFitRaw, ({ genres }) => genres);
